function RelatedArticlesSampleImageLogHeaders() {
  return (
    <div
      id="ts-relatedarticles-wrapper"
      className="w-full h-full flex items-center justify-center"
    >
      <div
        id="ts-relatedarticles-content"
        className="w-2/3 p-4 h-full flex flex-col items-center"
      >
        <div className="w-full relative flex items-center justify-center text-2xl p-2 border-b border-light-border">
          Sample IMAGELog Headers
        </div>
        <div className="w-full bg-gray-50 text-light-text p-6 mt-6 rounded-lg shadow-sm space-y-4">
          <p>
            TerraStation includes several sample IMAGELog headers for use with your log
            plots. These can be found in your userdata folder.
          </p>
          <p>
            If you want to display your standard log plots with a "standard" well log
            header, use the tsbasic.hdr file which you can append to any of your IMAGELog
            plots for a more professional appearance. It is completely editable by the user
            for all of the basic "Run information" you find on a downhole electric log.
          </p>
          <p>
            "Other services", KB, DF and GL elevations, location information, API well number,
            types of logs presented, and even the names of the logging company can be changed.
            You can also edit the line styles, line weights and the line colors. Slots are also
            provided for "equipment data" and "heading remarks". The file is an ASCII file
            which can be reviewed and edited with any text editor, then copied into your
            TerraStation II project directory.
          </p>
          <p>
            In addition to the basic header file, try the minimal header simple.hdr. This header
            file contains minimal well identification information.
          </p>
          <p>
            To learn how to unlock IMAGELog's advanced features, look at complog.hdr. This
            header file uses nearly all the IMAGELog features. Special thanks to Bill Bagby, of
            Conoco, for sharing this with us.
          </p>
          <p>A slightly more detailed version of the simple header - simple2.hdr.</p>
          <p>Another example, this one showing the use of filled boxes - ts2exam.hdr.</p>
          <p className="text-light-main italic">
            If you have an IMAGELog header file which you would be willing to share with
            others, please send it to your local TERRASCIENCES support office.
          </p>
        </div>
      </div>
    </div>
  );
}

export default RelatedArticlesSampleImageLogHeaders;
